import { useQuery } from "@tanstack/react-query";

import { TreemapParams, getTreemap } from "../../services/productPlaneApi";
import { queryKeys } from "./keys";

const STALE_TIME = 60 * 1000;
const GC_TIME = 5 * 60 * 1000;

/**
 * TanStack Query hook for the treemap of the classes of a selection of
 * products.
 *
 * The caller builds the request from the selection, the measure and the
 * jurisdictions.
 */
export function useTreemap(params: TreemapParams, enabled = true) {
  return useQuery({
    queryKey: queryKeys.productPlane.treemap(params),
    queryFn: () => getTreemap(params),
    enabled,
    staleTime: STALE_TIME,
    gcTime: GC_TIME,
  });
}
